export const hasElrondExtension = 'elrondWallet' in window;
